import React from 'react';
import Icon from '../atoms/Icon';

function FilmIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 32 25">
      <g
        fill='currentColor'
        fillRule='evenodd'
      >
        <path d='M4.83333 3.625C4.51286 3.625 4.20552 3.75231 3.97891 3.97891C3.75231 4.20552 3.625 4.51286 3.625 4.83333C3.625 5.1538 3.75231 5.46115 3.97891 5.68775C4.20552 5.91436 4.51286 6.04167 4.83333 6.04167C5.1538 6.04167 5.46115 5.91436 5.68775 5.68775C5.91436 5.46115 6.04167 5.1538 6.04167 4.83333C6.04167 4.51286 5.91436 4.20552 5.68775 3.97891C5.46115 3.75231 5.1538 3.625 4.83333 3.625Z' />
      </g>

      <g
        stroke='currentColor'
        stroke-width='2.41667'
        stroke-miterlimit='10'
        fill='none'
        fillRule='evenodd'
      >
        <path d='M1.20833 8.45834H30.2083M1.20833 1.20834H30.2083V22.9583H1.20833V1.20834Z' />
        <path d='M18.6083 8.45834L21.025 4.83334L18.6083 1.20834M24.4083 8.45834L26.825 4.83334L24.4083 1.20834M12.8083 8.45834L15.225 4.83334L12.8083 1.20834M7.00833 8.45834L9.425 4.83334L7.00833 1.20834' />
      </g>
    </Icon>
  );
}

export default React.forwardRef(FilmIcon);